import { render, staticRenderFns } from "./SpaceUtilization.vue?vue&type=template&id=15f79236"
import script from "./SpaceUtilization.vue?vue&type=script&lang=js"
export * from "./SpaceUtilization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports